<template>
	<Header v-if="!isCustomLayout" />
	<main>
		<router-view v-slot="{ Component }">
			<component
				:is="Component"
				@vue:mounted="onMainMounted"
				@vue:unmounted="onMainUnmounted"
			/>
		</router-view>
	</main>
	<!-- <Footer v-if="!isCustomLayout && isContentLoaded" /> -->
</template>
<script setup> 
import { computed } from "vue";
import { useRoute } from "vue-router";
import { ref } from 'vue';
import Header from "@/components/2026/HeaderBlock.vue";
// import Footer from "@/components/Footer.vue";

const isContentLoaded = ref(false);

function onMainMounted() {
  isContentLoaded.value = true;
}

function onMainUnmounted() {
  isContentLoaded.value = false;
}

const route = useRoute();

// const customLayoutRoutes = ["survey-end", "archive-2025"];


// const isCustomLayout = computed(() =>
//   customLayoutRoutes.includes(route.name)
// );
const isCustomLayout = computed(() =>
  route.meta.customLayout === true
);
</script>
<style lang="scss">
</style>

<!-- <script setup>
</script>

<template>
    <router-view></router-view>
</template>

<style scoped>
</style> -->